module.exports = __webpack_public_path__ + "bcf80fd2dab2fd3cfc566e3d5ebc909b.pdf";